import React from 'react';
import {
  Button,
  TableCell,
  TableRow,
  Chip,
  Avatar,
  Tooltip,
  Box,
} from '@material-ui/core';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import {
  PayingMemberPlanStatus,
  PayingMemberPlanStatusText,
} from '../../data/common';

const PayingMemberPlanTableRow = (props) => {
  const { plan, toEditPlan } = props;

  const handleEdit = () => {
    toEditPlan(plan.id);
  };

  // 檢查套券的分店是否與方案的分店一致
  const isStoreIdMismatch =
    plan.packageInfo &&
    plan.storeInfo &&
    plan.packageInfo.storeId !== plan.storeInfo.id;

  return (
    <TableRow>
      <TableCell component="th">{plan.id}</TableCell>
      <TableCell>{plan.name}</TableCell>
      <TableCell>$ {plan.price}</TableCell>
      <TableCell>
        {plan.storeInfo ? (
          <Chip
            size="small"
            label={plan.storeInfo.name}
            color="default"
            variant="outlined"
            avatar={
              plan.storeInfo.imgSrc ? (
                <Avatar src={plan.storeInfo.imgSrc} alt={plan.storeInfo.name} />
              ) : (
                undefined
              )
            }
          />
        ) : (
          <span style={{ color: '#999' }}>未設定</span>
        )}
      </TableCell>
      <TableCell>
        {plan.packageInfo ? (
          <Box display="flex" alignItems="center" gap={1}>
            <Chip
              size="small"
              label={plan.packageInfo.name}
              color="secondary"
            />
            {isStoreIdMismatch && (
              <Tooltip
                title={`警告：套券的分店設定與此方案的分店不一致！套券分店 ID: ${plan.packageInfo.storeId}`}
                arrow>
                <WarningRoundedIcon
                  style={{ color: '#f44336', fontSize: '20px' }}
                />
              </Tooltip>
            )}
          </Box>
        ) : (
          <span style={{ color: '#999' }}>未設定</span>
        )}
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          label={PayingMemberPlanStatusText[plan.status] ?? '未知'}
          color={
            plan.status === PayingMemberPlanStatus.ONLINE
              ? 'primary'
              : 'default'
          }
        />
      </TableCell>
      <TableCell align="right">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<EditRoundedIcon />}
          onClick={handleEdit}>
          編輯
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default PayingMemberPlanTableRow;
